import type { PoiDetailProps } from '@/components/feature/shop/shop-poi-modal/poi-detail-horizontal';
import { EXCLUDED_POI_FIELD_KEYS, POI_DISPLAY_TYPE } from '@/enums/poi';
import type { PoiContentSlide } from '@/types/shop';
import { getPoiDetailImageUrl } from './poiImage';

export const formatPoiSlideToDetail = (poiContent: PoiContentSlide | null, language: string): PoiDetailProps | null => {
    if (!poiContent) {
        return null;
    }

    const contents = poiContent.data.managedContents;
    const floorName = poiContent.floor;
    const buildingName = poiContent.buildingName;

    const imgUrlDetail = getPoiDetailImageUrl(contents, language);

    const keywords =
        contents
            ?.find((item) => item.display_type === POI_DISPLAY_TYPE.KEY_WORDS)
            ?.content?.[language]?.split(',')
            .filter((item) => !!item) || [];

    const listContent = contents
    ?.filter(({ display_type, field_key }) => 
        display_type === POI_DISPLAY_TYPE.TEXT && !EXCLUDED_POI_FIELD_KEYS.includes(field_key)
    )
    .map((item) => ({
                key: item.field_key,
                name: item.name,
                content: item.content,
            })) ?? [];

    const desc = contents?.find((item) => item.display_type === POI_DISPLAY_TYPE.DETAIL_DESC)?.content?.[language] ?? '';

    return {
        imgUrlDetail,
        floorName,
        buildingName,
        keywords,
        listContent,
        desc,
        poiName: poiContent.name,
    };
};
